import React from 'react'
import SEO from '../../seo/SEO'
import Brochuer_Banner from './Brochuer_Banner/Brochuer_Banner'
import Broucher_Second from './Broucher_Second/Broucher_Second'

const BROCHUREMain = () => {
  return (
      <>
      <SEO />
    <div>
        <Brochuer_Banner/>
        <Broucher_Second/>
    </div>
    </>
  )
}

export default BROCHUREMain

